/* 🤖 this file was generated by svg-to-ts */
export const mgcIconArrowRightRegular: {
  name: 'arrow-right-regular';
  data: string;
} = {
  name: 'arrow-right-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.617 5.417c-.183.079-.41.294-.508.479-.114.215-.121.659-.014.864.04.077.993 1.062 2.119 2.19L17.26 11h-6.683c-7.511 0-6.947-.023-7.271.3a.96.96 0 0 0 0 1.4c.324.323-.24.3 7.271.3h6.683l-2.046 2.05c-1.126 1.128-2.079 2.113-2.119 2.19-.107.206-.1.649.015.866.113.215.383.444.588.499.25.068.619.023.805-.096.182-.118 5.926-5.87 6.04-6.049.06-.094.077-.194.077-.46 0-.301-.012-.358-.106-.5-.059-.088-1.436-1.486-3.06-3.107-3.224-3.215-3.015-3.034-3.494-3.031a1.082 1.082 0 0 0-.343.055"/></svg>`
};
